import React, { memo, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const DrawnPath = memo(({drawnPath, currentPosition=0}) => { 
    if (!drawnPath || drawnPath.length < 2) { return []; };
    drawnPath  = sparse(drawnPath);
    let curve = "M " + drawnPath.map(p => p.x + ' ' + p.y).join(' ');
    return (
          <path
            d={curve} className="drawn-path"/>
    );
});

const sparse = (l) => {
    let _l = [];
    let i=0;
    let last = undefined;
    for (let e of l) {
        if (last && last.x === e.x && last.y === e.y) {
            i++;
            continue;
        }
        if (i%3===0 || i===l.length-1) {
            _l.push(e);
            last = e;
        }
        i++;
    }
    return _l;
};

/*
const mapStateToProps = (state, props) => {
    return {
        drawnPath: props.effect.currentPath
    };
};
*/

export default connect(null,null)(DrawnPath);
